import styled from 'styled-components';

/**
 * Styled component for horizontal rules
 */
export const HR = styled.hr`
	margin: 16px;
	margin-bottom: 0;
`;
